import { render, staticRenderFns } from "./DelayedValue.vue?vue&type=template&id=3ef246ec&scoped=true&"
import script from "./DelayedValue.vue?vue&type=script&lang=js&"
export * from "./DelayedValue.vue?vue&type=script&lang=js&"
import style0 from "./DelayedValue.vue?vue&type=style&index=0&id=3ef246ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef246ec",
  null
  
)

export default component.exports